import React from 'react';
import { Modal, Button } from 'react-bootstrap'
import { Form } from 'fw/forms';
import { RoleCombo } from 'areas/shared/controls'

class LoadFromTemplateModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			form: {},
			visible: false
		};
	}

	// API
	open = () => {
		this.setState({ 
			form: {},
			visible: true
        });
	}
	
	close = () => {
		this.setState({
			visible: false
		}, function () {
			this.props.onClose && this.props.onClose();
		});
	}

	confirm = (roleId) => {
		this.setState({
			visible: false
		}, function () {
			this.props.onConfirm && this.props.onConfirm(roleId);
		});
	}
	
	// Handlers
	handleChange = (form) => {
		this.setState({ form });
	}

	handleCancel = () => {
        this.close();
	}

	handleEntered = () => {
	}

	handleSubmit = () => {
		this.confirm(this.state.form.roleId);
    }
	
	// React
	render() {
		return (
			<Modal show={this.state.visible} onHide={this.handleCancel} onEntered={this.handleEntered}>
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}>
					<Modal.Header>
						<Modal.Title>Load role privileges from template</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<span>Please select the role from which to copy the privileges:</span><br />
						<RoleCombo name="roleId" required />
					</Modal.Body>
					<Modal.Footer>
						<Button bsStyle="link" onClick={this.handleCancel}>Cancel</Button>
						<Button bsStyle="primary" type="submit">Confirm</Button>
					</Modal.Footer>
				</Form>
			</Modal>
		)
	}
}

export default LoadFromTemplateModal;



// WEBPACK FOOTER //
// ./src/areas/admin/roleSetup/roleInfo/LoadFromTemplateModal.js